import { Reveal } from "@/components/Reveal";
import { PageFlip } from "@/components/books/PageFlip";

export const SamplePages = () => (
  <section className="py-24" data-testid="book-sample-pages">
    <div className="max-w-[1000px] mx-auto px-6 lg:px-10">
      <Reveal>
        <p className="overline mb-4" style={{ color: "var(--gold)" }}>Peek inside</p>
        <h2 className="font-display text-4xl md:text-5xl mb-4" style={{ color: "var(--navy)" }}>A story they'll <span className="italic" style={{ color: "var(--turquoise)" }}>read again and again.</span></h2>
        <p className="font-body font-light max-w-xl mb-12" style={{ color: "var(--muted)" }}>
          Turn the pages to see how your little swimmer becomes the star — from swim day to floating like a pro.
        </p>
      </Reveal>
      <Reveal delay={0.1}><PageFlip /></Reveal>
    </div>
  </section>
);
